import { persistReducer, persistStore } from "redux-persist";
import storage from 'redux-persist/lib/storage';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from "./reducers";

const STORE_CONFIG = {
    persist: {
        key: 'root',
        storage,
    }
};

const handleStoreError = (error, context) => {
    console.error(`Store ${context}:`, error);
    throw error;
};

const configureMiddleware = (getDefaultMiddleware) => 
    getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: ['persist/PERSIST']
        }
    });

const initializeStore = (preloadedState) => {
    try {
        const persistedReducer = persistReducer(STORE_CONFIG.persist, rootReducer);
        
        return configureStore({
            reducer: persistedReducer,
            preloadedState,
            middleware: configureMiddleware,
            // DevTools are enabled by default in development
            devTools: process.env.NODE_ENV === 'development'
        });
    } catch (error) {
        handleStoreError(error, 'initialization failed');
    }
};

export const store = initializeStore();
export const persistor = persistStore(store);